import React from "react";

type Props = React.PropsWithChildren<{
  header: React.ReactNode | JSX.Element;
  className?: string;
}>;

export const Card = (props: Props) => {
  return (
    <div className={`row gx-0 ${props.className}`}>
      <div className="col-12">
        <div className="content-box bg-white h-100">
          <div className="content-box-header">{props.header}</div>
          <div className="collapse show clearfix position-relative">
            <div className="border-top"></div>
            <div className="content-box-body">{props.children}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
